import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, getValidUrl, isColorBright } from '../../lib/ep';

import ActionLink from '../builder/ActionLink';

const LinkEmbed = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const type = props?.type ?? 'big';
	const main_color = (props.main_color != undefined) ? props.main_color : ((props.color != undefined) ? props.color : '#2951CC');
	const text_color = (isColorBright(main_color)) ? '0, 0, 0' : '255, 255, 255';

	let link = props?.url ?? false;
	
	if(!link) return null;

	const is_builder = props?.is_builder ?? false;
	let title = props?.title ?? false;
	let description = props?.description ?? false;
	if(type == 'gallery' && !is_builder && description && description.trim().length > 100) description = description.substr(0, 100).trim() + "...";

	link = getValidUrl(link);

	return (
		<div class={`gallery_description is_link is_${type}`} style={{background:main_color, '--main-color':`${text_color}, 1`, '--p-color':`${text_color}, 1`, '--secondary-color':text_color}}>
			<div class="cover_info">
				{(type == 'thumb') && (
					<h4 class="is_title original_color_item mod_align_center">{i18n("Link")}</h4>
				)}
				
				{(title && type != 'thumb') && (
					
					<p class="is_title original_color_item mod_align_center">
						{(type == 'big') && (
							<ActionLink _href={link} _target="_blank" _class={{icon:'knk-view'}}>{title}</ActionLink>
						)}

						{(type != 'big') && (
							<ActionLink _class={{icon:'knk-view'}}>{title}</ActionLink>
						)}
					</p>
				)}

				{(description && type != 'thumb') && (
					<p class="is_description original_color_item mod_align_center" dangerouslySetInnerHTML={{ __html:description.replace(/\n/g, '<br />') }} />
				)}
			</div>
		</div>
	)
};

export default injectIntl(LinkEmbed);